export const RESOURCES = {
  cards:                    '/cards/:id',
  card_no:                 '/cards/auto/numer',
  card_transactions:        '/cards/:card_id/transactions',
  reset_pin:        		'/cards/:card_id/pin/reset',
  invoices:                 '/invoices/:id',
  invoice_pdf:              '/invoice/:id',
  agreement:                '/agreement/:id',
  limits:                   '/limits/:id',
  fleet_groups:             '/fleet_groups',
  daily_sales:              '/stats/daily_sales',
  fleet_usage_level:        '/stats/fleet_usage_level',
  fleet_quantitative_usage: '/stats/fleet_quantitative_usage',
  fleet_usage:              '/stats/fleet_usage',
  transactions:             '/transactions'
};



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/resources.ts